import { emptyResourceSummary } from '@/store/defaults';
export const getters = {
    categories: (state) => {
        return state.currentResponse.categories || [];
    },
    resourceTypeSummary: (state) => {
        return state.currentResponse.resourceTypeSummary || emptyResourceSummary;
    },
    total(state) {
        return state.currentResponse.total || 0;
    },
    nextPageRequest(state) {
        const currentOffset = state.currentSearchRequest.Offset || 0;
        const limit = state.currentSearchRequest.Limit || 0;
        const search = { ...state.currentSearchRequest };
        search.Offset = Number(currentOffset) + Number(limit);
        return search;
    },
    prevPageRequest(state) {
        const currentOffset = state.currentSearchRequest.Offset || 0;
        const limit = state.currentSearchRequest.Limit || 0;
        const search = { ...state.currentSearchRequest };
        search.Offset = Number(currentOffset) + Number(limit);
        return search;
    },
    currentRequest(state) {
        return state.currentSearchRequest;
    },
    currentResponse(state) {
        return state.currentResponse;
    },
    isSearching(state) {
        return state.isSearching;
    },
};
